// extracted by mini-css-extract-plugin
export var arrows = "_65-5";
export var decrementer = "_65-9";
export var disabled = "_65-3";
export var error = "_65-1";
export var hiddenText = "_65-a";
export var incrementer = "_65-8";
export var input = "_65-7";
export var inputWrapper = "_65-0";
export var leadingIcon = "_65-b";
export var readonly = "_65-2";
export var regular = "_65-6";
export var small = "_65-4";